export default __webpack_public_path__ + "media/images/expand-62b761ddf488aef61943a56dc72bc7c8.svg";